import { Column } from "@tanstack/react-table";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

export const SortUser = <TData,>(columnName: string, column: Column<TData, unknown>) => {
  if (!column.getCanSort()) {
    return <span>{columnName}</span>;
  }

  const sorted = column.getIsSorted();
  const Icon = sorted === "asc" ? ArrowUp : sorted === "desc" ? ArrowDown : ArrowUpDown;

  return (
    <button
      type="button"
      className="flex items-center cursor-pointer bg-transparent border-none p-0"
      onClick={() => column.toggleSorting(sorted === "asc")}
    >
      <span>{columnName}</span>
      <Icon className="ml-2 h-4 w-4" />
    </button>
  );
};
